module.exports = [
	{
		"src": "bosch.jpg",
		"msrc": "bosch_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "bulul.jpg",
		"msrc": "bulul_tn.jpg",
		"w": 2000,
		"h": 3000
	},
	{
		"src": "caryatid.jpg",
		"msrc": "caryatid_tn.jpg",
		"w": 2000,
		"h": 1997
	},
	{
		"src": "eshu.jpg",
		"msrc": "eshu_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "fire-and-death-notes.jpg",
		"msrc": "fire-and-death-notes_tn.jpg",
		"w": 2000,
		"h": 1647
	},
	{
		"src": "gaki.jpg",
		"msrc": "gaki_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "goddesses.jpg",
		"msrc": "goddesses_tn.jpg",
		"w": 2000,
		"h": 1980
	},
	{
		"src": "graves-moon.jpg",
		"msrc": "graves-moon_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "gunungan.jpg",
		"msrc": "gunungan_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "iamb.jpg",
		"msrc": "iamb_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "konarak.jpg",
		"msrc": "konarak_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "lolas.jpg",
		"msrc": "lolas_tn.jpg",
		"w": 2000,
		"h": 1317
	},
	{
		"src": "mebuyan.jpg",
		"msrc": "mebuyan_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "moon-goddess.jpg",
		"msrc": "moon-goddess_tn.jpg",
		"w": 2000,
		"h": 1004
	},
	{
		"src": "moon-music.jpg",
		"msrc": "moon-music_tn.jpg",
		"w": 2000,
		"h": 2638
	},
	{
		"src": "mushroom2.jpg",
		"msrc": "mushroom2_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "mushroom3.jpg",
		"msrc": "mushroom3_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "naga.jpg",
		"msrc": "naga_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "omphalos.jpg",
		"msrc": "omphalos_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "starry-vincent.jpg",
		"msrc": "starry-vincent_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "tender-moment.jpg",
		"msrc": "tender-moment_tn.jpg",
		"w": 2000,
		"h": 1333
	},
	{
		"src": "tengu.jpg",
		"msrc": "tengu_tn.jpg",
		"w": 2000,
		"h": 3000
	},
	{
		"src": "vesta.jpg",
		"msrc": "vesta_tn.jpg",
		"w": 2000,
		"h": 1256
	},
	{
		"src": "yabyum.jpg",
		"msrc": "yabyum_tn.jpg",
		"w": 2000,
		"h": 1333
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./public/notebooks/images.json
 ** module id = 13
 ** module chunks = 0
 **/